import BaseComponent from '../../../js/base-component'
import { Splide } from '@splidejs/splide/build/complete/complete';

class AdviserIndex extends BaseComponent {
    constructor(options) {
        super(options);

        // setup hover state
        let mql = window.matchMedia('(min-width: 1024px)'),
            rootEle = document.querySelector(".u-adviser-index"),
            indexItems = document.querySelectorAll(".u-adviser-index__item.has--items"),
            overlay = document.querySelector(".u-adviser-index__overlay"),
            overlayHeight = 2.75,

        //methods
        setup = function() {
            indexItems.forEach((element) => element.addEventListener('mouseenter', addHover) );
            indexItems.forEach((element) => element.addEventListener('mouseleave', removeHover) );

        },
        addHover = function(evt) {
            let lineHeight = 2,
            sublist = evt.target.children[1],
            subItemsCount = sublist.children.length,
            containerHeight = overlayHeight + (lineHeight * subItemsCount);

            rootEle.classList.add('u-adviser-index--hover');
            overlay.style.height = containerHeight + "rem";
            sublist.classList.add('show');

            setTimeout(function(){
                sublist.style.height = 0.75 + (lineHeight * subItemsCount) + "rem";
                sublist.style.opacity = 1;
            }, 100);
        },
        removeHover = function(evt) {
            let sublist = evt.target.children[1];

            overlay.style.height = '2rem';
            sublist.style.height = 0;
            sublist.style.opacity = 0;
            rootEle.classList.remove('u-adviser-index--hover');

            setTimeout(function() {
                sublist.classList.remove('show');
            }, 300);
        };

        if( rootEle && mql.matches ) {
            setup();
        }

        // set stucked state -- is--pinned (+2 to overlap sticky container position)
        const ai = document.querySelector(".u-list-teaser__adviser-index .u-adviser-index");
        const headerHeight = document.querySelector(".u-header");
        const naviHeight = document.querySelector(".u-navigation--main");

        if (ai && headerHeight && naviHeight) {
            const observer = new IntersectionObserver(
                ([e]) => e.target.classList.toggle("is--pinned", e.intersectionRatio < 1),
                {
                    // root: document.querySelector('.u-header'),
                    rootMargin:'-' + (headerHeight.clientHeight + naviHeight.clientHeight + 2 ) + 'px 0px 0px 0px',
                    threshold: [1],
                }
            );

            observer.observe(ai);
        }
    }
}

export default {
  name: 'AdviserIndex',
  definition: AdviserIndex
};